"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Dialog = exports.Dialog = _styledComponents["default"].div.attrs({
  role: 'dialog'
}).withConfig({
  displayName: "Dialog",
  componentId: "sc-18qzfns-0"
})(["", ";", ";padding-block-start:", ";inline-size:335px;overflow-wrap:break-word;"], (0, _index.rootStyle)(), function (props) {
  return (0, _index.dialog)({
    colorSet: props.$colorSet
  });
}, (0, _index.cssSpacing)('base', '16px'));